var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 54,
    viewBox: "0 0 64 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.103152 1.59814H28.7549V30.2787L17.2654 53.2578H2.98273L14.4147 30.2787H0.103152V1.59814Z",
    fill: "#7B1FFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6581 0.761963H63.3099V29.4425L51.8204 52.4216H37.5377L48.9696 29.4425H34.6581V0.761963Z",
    fill: "#7B1FFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.5cebde65eb160498dc97821a5047255c.svg";
export { ForwardRef as ReactComponent };